<template>
  <div>
    <v-checkbox
      class="py-0 my-0 mr-2 d-inline-block"
      v-model="showAbsent"
      hide-details
      dense
      color="primary"
      @change="onChange"
      :label="$t('ACCOUNT.SET_AWAY')"
    />
    <v-tooltip dark bottom max-width="300px">
      <template v-slot:activator="{ on }">
        <v-icon class="mb-1" size="20" color="primary" v-on="on">fas fa-info-circle</v-icon>
      </template>
      <span>{{ $t('TOOLTIP.AWAY_INFO') }}</span>
    </v-tooltip>

    <transition name="slide-y-transition">
      <div v-show="showAbsent">
        <v-layout align-center row wrap>
          <v-flex pb-0 pt-4>
            <v-dialog
              ref="startDateDialog"
              v-model="openStartDateModal"
              :return-value.sync="startDate"
              lazy
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="formatedStartDate"
                  :label="$t('ACCOUNT.START_DATE_AWAY')"
                  :error-messages="errors.absent_since"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="startDate" scrollable>
                <v-spacer></v-spacer>
                <tk-btn flat color="primary" @click="openStartDateModal = false">Cancel</tk-btn>
                <tk-btn
                  flat
                  color="primary"
                  @click="$refs.startDateDialog.save(startDate); errors.absent_since = null"
                >OK</tk-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>

          <v-flex pb-0 pt-4>
            <v-dialog
              ref="endDateDialog"
              v-model="openEndDateModal"
              :return-value.sync="endDate"
              lazy
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="formatedEndDate"
                  :label="$t('ACCOUNT.RETURN_DATE_AWAY')"
                  :error-messages="errors.absent_until"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="endDate" scrollable>
                <v-spacer></v-spacer>
                <tk-btn flat color="primary" @click="openEndDateModal = false">Cancel</tk-btn>
                <tk-btn
                  flat
                  color="primary"
                  @click="$refs.endDateDialog.save(endDate); errors.absent_until = null"
                >OK</tk-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>

          <v-flex text-xs-right shrink pb-0 pt-4>
            <tk-btn :loading="saving" color="primary" @click="save">
              <span>{{ $t('COMMON.SAVE') }}</span>
            </tk-btn>
          </v-flex>
        </v-layout>
      </div>
    </transition>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";
import { sleep } from "@/utils/AsyncHelpers";

const usersRepo = RepositoryFactory.users();
const handler = new ErrorHandler();

export default {
  props: ['absence'],

  data() {
    return {
      showAbsent: false,
      startDate: null, // for dialog
      endDate: null, // for dialog
      formatedStartDate: null, // for text field
      formatedEndDate: null, // for text field
      openStartDateModal: false,
      openEndDateModal: false,
      saving: false,
      errors: {}
    };
  },
  watch: {
    startDate(val) {
      console.log("startdate", val);
      this.formatedStartDate = this.formatDate(this.startDate);
    },
    endDate(val) {
      this.formatedEndDate = this.formatDate(this.endDate);
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      if (this.absence.id) {
        this.showAbsent = true;
        this.startDate = this.formatCalendarDate(
          new Date(this.absence.absentSince)
        );
        this.endDate = this.formatCalendarDate(
          new Date(this.absence.absentUntil)
        );
      }
    },

    formatCalendarDate(date) {
      return `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(
        -2
      )}-${("0" + date.getDate()).slice(-2)}`;
    },

    async onChange(e) {
      console.log("onChange", e);

      if (!e && this.absence.id) {
        const confirm = await this.$root.$confirm(
          "Remove away",
          "Are you sure?",
          { color: "primary" }
        );

        if (confirm) {
          console.log("Delete the absence");
          if (this.absence.id) {
            try {
              await usersRepo.removeAbsence(this.absence.id);
            } catch (error) {
              console.log(error);
              this.showAbsent = true;
            }
          }
        } else {
          this.showAbsent = true;
        }
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    async save() {
      this.errors = {};
      this.saving = true;

      try {
        const res = await usersRepo.createAbsence(
          this.formatedStartDate,
          this.formatedEndDate
        );
        console.log(res);
        this.absence.id = res.id;
        this.$app.toast(this.$t("COMMON.SAVED"));
      } catch (error) {
        if (error.status === 422 && error.data) {
          this.errors = error.data.errors;
          console.log(this.errors);
        }
      }

      this.saving = false;
    }
  }
};
</script>
